export default __webpack_public_path__ + "static/media/img_1.4dd96a2f.jpg";